import styled from '@emotion/styled'

const Stack = styled.div`
    display: ${({display}) => display || 'block'};
    align-items: ${({alignItems}) => alignItems || 'center'};
`
export default Stack


// WEBPACK FOOTER //
// ./src/components/Common/Stack/Stack.js